import { Avatar } from '@outbound-ai/ursa'
import { generateHSLString } from 'utils/helper'

interface IProps {
  claimOwner: string | null | undefined
}

export const ClaimOwnerAvatar = ({ claimOwner }: IProps) => {
  if (!claimOwner) {
    return <></>
  }
  const fullName = claimOwner.split(' ')
  const hsl = generateHSLString(fullName[0] + fullName[1])

  const initials =
    fullName.length >= 2
      ? (fullName.shift()!.charAt(0) + fullName.pop()!.charAt(0)).toUpperCase()
      : fullName.shift()!.charAt(0)

  return <Avatar initials={initials} size="small" backgroundColor={hsl} color="#31457b" />
}
